import LayoutV2 from "containers/LayoutV2";
import React, { useEffect, useState, useRef } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import { pushNotification } from "utils/notifications";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import SearchForm from "./SearchForm";
import HangSanXuatTable from "./TabHangSanXuat/HangSanXuatTable";
import MenuChucNang from "./MenuChucNang";
import DongSanPhamTable from "./TabDongSanPham/DongSanPhamTable";
import ThuocTinhGiamTruTable from "./TabThuocTinhGiamTru/ThuocTinhGiamTruTable";


const ThuocTinhGiamTru = () => {
    const [loading, setLoading] = useState(true);
    const [dataResponse, setdataResponse] = useState([]);
    //role
    const [hasPermission, setHasPermission] = useState(null);
    const [RoleThemMoiHangSanXuat, setRoleThemMoiHangSanXuat] = useState(null);
    const [RoleSuaHangSanXuat, setRoleSuaHangSanXuat] = useState(null);
    const [RoleXoaHangSanXuat, setRoleXoaHangSanXuat] = useState(null);
    const [RoleThemMoiDongSanPham, setRoleThemMoiDongSanPham] = useState(null);
    const [RoleSuaDongSanPham, setRoleSuaDongSanPham] = useState(null);
    const [RoleXoaDongSanPham, setRoleXoaDongSanPham] = useState(null);
    const [RoleThemMoiThuocTinhGiamTru, setRoleThemMoiThuocTinhGiamTru] = useState(null);
    const [RoleSuaThuocTinhGiamTru, setRoleSuaThuocTinhGiamTru] = useState(null);
    const [RoleXoaThuocTinhGiamTru, setRoleXoaThuocTinhGiamTru] = useState(null);

    const [activeTab, setActiveTab] = useState("HangSanXuat");
    const [listCauHinhTaiSan, setlistCauHinhTaiSan] = useState([]);

    useEffect(() => {
        document.title = "Thuộc tính giảm trừ | Phần mềm quản lý cầm đồ - Morman";
        fetchPermission();
    }, []);
    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("thuoctinhgiamtru"));
            setRoleThemMoiHangSanXuat(roles.includes("thuoctinhgiamtru_themmoihangsanxuat"));
            setRoleSuaHangSanXuat(roles.includes("thuoctinhgiamtru_suahangsanxuat"));
            setRoleXoaHangSanXuat(roles.includes("thuoctinhgiamtru_xoahangsanxuat"));
            setRoleThemMoiDongSanPham(roles.includes("thuoctinhgiamtru_themmoidongsanpham"));
            setRoleSuaDongSanPham(roles.includes("thuoctinhgiamtru_suadongsanpham"));
            setRoleXoaDongSanPham(roles.includes("thuoctinhgiamtru_xoadongsanpham"));
            setRoleThemMoiThuocTinhGiamTru(roles.includes("thuoctinhgiamtru_themmoithuoctinhgiamtru"));
            setRoleSuaThuocTinhGiamTru(roles.includes("thuoctinhgiamtru_suathuoctinhgiamtru"));
            setRoleXoaThuocTinhGiamTru(roles.includes("thuoctinhgiamtru_xoathuoctinhgiamtru"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
            setRoleThemMoiHangSanXuat(false);
            setRoleSuaHangSanXuat(false);
            setRoleXoaHangSanXuat(false);
            setRoleThemMoiDongSanPham(false);
            setRoleSuaDongSanPham(false);
            setRoleXoaDongSanPham(false);
            setRoleThemMoiThuocTinhGiamTru(false);
            setRoleSuaThuocTinhGiamTru(false);
            setRoleXoaThuocTinhGiamTru(false);
        }
    };
    const SearchData = useRef({
        CauHinhTaiSanId: "",
    });

    const loadDanhSachCauHinhTaiSan = async () => {
        try {
            const res = await ThuocTinhGiamTruApi.danhsachcauhinhtaisan();
            const list = res.data.List || [];
            setlistCauHinhTaiSan(list);
            return list;
        } catch (error) {
            console.error("Lỗi load danh sách cấu hình tài sản:", error);
            setlistCauHinhTaiSan([]);
            return [];
        }
    }
    const onSearch = async (id = null) => {
        try {
            setLoading(true);
            let list = listCauHinhTaiSan;
            if (!list || list.length === 0) {
                list = await loadDanhSachCauHinhTaiSan();
            }
            let searchId = id;
            if (!searchId && list.length > 0) {
                searchId = list[0].CauHinhTaiSanId;
            }
            console.log("data cau hinh: ", list);
            if (searchId) {
                SearchData.current.CauHinhTaiSanId = searchId;
                const res = await ThuocTinhGiamTruApi.getDataByCauHinhTaiSanID({ id: searchId });
                setdataResponse(res.data || []);
                console.log("data response: ", res.data);
            } else {
                SearchData.current.CauHinhTaiSanId = "";
                setdataResponse([]);
            }
        } catch (error) {
            console.error("Lỗi load data Thuộc tính giảm trừ:", error);
            setdataResponse([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (hasPermission) {
            onSearch(SearchData.current.CauHinhTaiSanId);
            const savedTab = sessionStorage.getItem("activeTab_ThuocTinhGiamTru");
            if (savedTab) {
                setActiveTab(savedTab);
            }
        }
    }, [hasPermission]);
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        sessionStorage.setItem("activeTab_ThuocTinhGiamTru", tab);
    };


    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }

    return (
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-cau-hinh-tai-san.png"
                                                    alt="logo"
                                                    style={{ maxWidth: "30px" }}
                                                />
                                                <h1 className="text-info-home">Quản trị hệ thống - Thuộc tính giảm trừ</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                                style={{}}
                            >
                                <div className="card-body card-body-v2">
                                    <SearchForm
                                        onSearch={onSearch}
                                        listCauHinhTaiSan={listCauHinhTaiSan}
                                    />
                                </div>
                            </div>
                            {loading && (<>
                                <div className="loader loader-default is-active"></div>
                            </>)}
                            {!loading && (<>
                                <div
                                    className="card border-light mb-3 card-v2"
                                    style={{ marginTop: "-35px" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                                        <div className="card-body card-body-v2" style={{ display: RoleThemMoiHangSanXuat ? "block" : "none", marginTop: "-5px", marginBottom: "10px", maxHeight: "35px" }}>
                                            <MenuChucNang
                                            />
                                        </div>
                                        <div className="tab-content px-1 pb-1 bg-content-tab">
                                            <div role="tabpanel" className="tab-pane  active" id="hang-san-xuat" aria-expanded="true" aria-labelledby="base-tab1">
                                                <HangSanXuatTable
                                                    list={dataResponse.HangSanXuat}
                                                    RoleThemMoiHangSanXuat={RoleThemMoiHangSanXuat}
                                                    RoleSuaHangSanXuat={RoleSuaHangSanXuat}
                                                    RoleXoaHangSanXuat={RoleXoaHangSanXuat}
                                                    listCauHinhTaiSan={listCauHinhTaiSan}
                                                    onSearch = {onSearch}
                                                />
                                            </div>
                                            <div className="tab-pane" id="dong-san-pham" aria-expanded="true" aria-labelledby="base-tab2">
                                                <DongSanPhamTable
                                                    list={dataResponse.DongSanPham}
                                                    listHangSanXuat={dataResponse.HangSanXuat}
                                                    listCauHinhTaiSan={listCauHinhTaiSan}
                                                    RoleThemMoiDongSanPham={RoleThemMoiDongSanPham}
                                                    RoleSuaDongSanPham={RoleSuaDongSanPham}
                                                    RoleXoaDongSanPham={RoleXoaDongSanPham}
                                                    onSearch = {onSearch}
                                                />
                                            </div>
                                            <div className="tab-pane" id="thuoc-tinh-giam-tru" aria-expanded="true" aria-labelledby="base-tab3">
                                                <ThuocTinhGiamTruTable
                                                    list={dataResponse.ThuocTinhGiamTru}
                                                    RoleThemMoiThuocTinhGiamTru={RoleThemMoiThuocTinhGiamTru}
                                                    RoleSuaThuocTinhGiamTru={RoleSuaThuocTinhGiamTru}
                                                    RoleXoaThuocTinhGiamTru={RoleXoaThuocTinhGiamTru}
                                                    listCauHinhTaiSan={listCauHinhTaiSan}
                                                    onSearch = {onSearch}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>
            </div>
        </LayoutV2>
    );
}

export default ThuocTinhGiamTru;